import { useLocation } from 'react-router-dom';

// Reads the analytics `source` value passed via React Router location state
// (e.g. navigate('/results/123', { state: { analyticsSource: 'sidebar' } }))
// Falls back to 'direct' when the user landed without a known entry point
// (deep link, refresh, or a navigator that didn't tag itself).
export const useAnalyticsSource = <T extends string = string>(
  fallback: T = 'direct' as T,
): T => {
  const { state } = useLocation();
  const source = (state as { analyticsSource?: T } | null)?.analyticsSource;
  return source ?? fallback;
};
